import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import {DataExportComponent} from './data-export.component';
import { DataExportRoutingModule } from './data-export-routing.module';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [DataExportComponent],
  imports: [
    CommonModule,
    DataExportRoutingModule,
    FormsModule,
    TranslateModule
  ],
  exports:[DataExportComponent, TranslateModule],
})
export class DataExportModule { }
